import { Button } from "../button";

import { useTranslation } from "react-i18next";
import "../../utils/i18next";
import { useAos } from "../../utils/aos";

export function Chart() {
  const { t } = useTranslation();
  useAos();
  return (
    <section className="chart relative pb-[118px] pt-[69px] md:pt-[131px] md:pb-[118px] text-center">
      <div className="gradient-decor max-w-[200px] max-h-[200px] bottom-0 right-[-10%] absolute md:max-w-[412px] md:max-h-[412px] w-full h-full md:right-[-20%] md:top-[-20%]"></div>
      <div className="container">
        <div data-aos="fade-right" className="relative z-[2]">
          <h2 className="max-w-[288px] mx-auto font-extrabold text-[24px] relative z-[2] md:text-[30px] lg:text-[40px] md:max-w-[537px] mx-auto leading-[125%]">
            {t("chart.title")}
          </h2>
          <p className="max-w-[288px] md:max-w-[680px] mx-auto mt-[24px] md:mt-[31px] text-[14px] md:text-[18px] leading-[167%]">
            {t("chart.text")}
          </p>
          <dotlottie-player
            src="lottie/graph.lottie"
            autoplay
            loop
            class="mx-auto mt-[30px] max-w-[700px] mx-auto"
            style={{ height: "100%", width: "100" }}
          />
          <Button
            buttonClass="button mx-auto transition-all block text-center text-[16px] md:text-[20px] mt-[28px] max-w-[190px] md:max-w-[247px] w-full"
            buttonText={t("chart.button")}
            buttonUrl="#"
          />
        </div>
      </div>
    </section>
  );
}
